/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tired_Formal_Mayfly_GazeInputs */

const fr_tired_formal_mayfly_gaze = /** @type {(inputs: Tired_Formal_Mayfly_GazeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilisateurs`)
};

/**

* @param {Tired_Formal_Mayfly_GazeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const tired_formal_mayfly_gaze = /** @type {((inputs?: Tired_Formal_Mayfly_GazeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tired_Formal_Mayfly_GazeInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_tired_formal_mayfly_gaze(inputs)
});